import React from 'react';

const Header = () => (
  <div className="header-content">
    <h1>
      How much would vouchers <span className="header-emphasis">defund my&nbsp;school?</span>
    </h1>
  </div>
);

export default Header; 